<template>
  <div class="space-y-8 text-center">
    <h2 class="text-2xl font-bold">{{ $t("form.step3.title") }}</h2>

    <div class="grid grid-cols-1 gap-6 mx-auto max-w-lg sm:grid-cols-2">
      <div
        @click="selectGift('warranty')"
        :class="[
          'p-6 border-2 rounded-xl cursor-pointer transition-all flex flex-col items-center justify-center gap-4',
          formData.gift === 'warranty'
            ? 'border-brand-red bg-red-50 shadow-md'
            : 'border-gray-300 hover:border-gray-400',
        ]"
      >
        <WarrantyIcon />
        <span class="font-semibold text-brand-dark">{{
          $t("form.step3.gift1Title")
        }}</span>
      </div>
      <div
        @click="selectGift('replacement')"
        :class="[
          'p-6 border-2 rounded-xl cursor-pointer transition-all flex flex-col items-center justify-center gap-4',
          formData.gift === 'replacement'
            ? 'border-brand-red bg-red-50 shadow-md'
            : 'border-gray-300 hover:border-gray-400',
        ]"
      >
        <ReplacementIcon />
        <span class="font-semibold text-brand-dark">{{
          $t("form.step3.gift2Title")
        }}</span>
      </div>
    </div>
    <p v-if="errors.gift" class="-mt-4 text-xs text-red-500">
      {{ errors.gift }}
    </p>

    <p class="px-4 text-brand-gray">{{ $t("form.step3.confirmation") }}</p>

    <div class="pt-4">
      <button
        @click.prevent="onSubmit"
        class="px-12 py-3 w-full font-bold text-white rounded-lg transition-all bg-brand-blue hover:bg-opacity-90 sm:w-auto"
        :class="{'opacity-75 cursor-not-allowed': loading}"

      >
        <SpinnerIcon v-if="loading" />
        <span v-else>{{ $t("form.step3.activateButton") }}</span>
      </button>
    </div>
  </div>
</template>
<script>
import { WarrantyIcon, ReplacementIcon,SpinnerIcon} from "./icons/";

export default {
  name: "FormStep3",
  components: {
    WarrantyIcon,
    ReplacementIcon,
    SpinnerIcon
  },
  props: {
    formData: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
        type: Boolean,
        default: false
    }
  },
  methods: {
    selectGift(gift) {
      this.$emit("update-form-data", { gift: gift });
    },
    onSubmit() {
      this.$emit("activate-gift");
    },
  },
};
</script>
